export const getFirstDomainName = (domain: string) =>  domain.split('.')[0]